import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Outsourced} from "../Outsourced";
import {gsap} from "gsap";
import {OutsourcedSound} from "../sound/OutsourcedSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {RestoreUtils} from "../utils/RestoreUtils";

export class OutsourcedBetPresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        const isQuickStop = Outsourced.apiPlugin.settings.get(APISetting.FAST_SPIN);
        RestoreUtils.isActionSpins = false;

        tl.add(Outsourced.soundPlayer.playLoopBased(OutsourcedSound.REEL_SPINNING));
        tl.add(() => {

            const targetMultiplier = Outsourced.model.startingMultiplier();
            const bruh = Outsourced.reelView.multipliers.map((mul) => parseInt(mul.text.slice(1), 10) > 1).reduce((a, b) => a && b, true);
            if (bruh && Outsourced.model.hasStartingMultipliers()) {
                Outsourced.reelView.resetMultipliers(targetMultiplier);
                Outsourced.reelView.updateWays(targetMultiplier == 5 ? 16000 : 4096);
            } else {
                Outsourced.reelView.resetMultipliers();
                Outsourced.reelView.updateWays(256);
            }
            Outsourced.reelView.insertSymbols();
        });

        const stickyScatter = Outsourced.model.buyFeatureName == "BOOSTED_BET" &&
                              Outsourced.reelView.getSymbolAt(1, 0).symbolName == "SC";

        const reels = stickyScatter
                      ? Outsourced.reelView.reelModels.filter((reel, index) => index != 4)
                      : Outsourced.reelView.reelModels;

        const isFastSpins = Outsourced.apiPlugin.settings.get(APISetting.FAST_SPIN);
        if (isFastSpins) {
            reels.forEach((reel, index) => tl.add(reel.start(), 0));
        } else {
            reels.forEach((reel, index) => {
                const fixedIndex = (stickyScatter && index > 3) ? index + 1 : index;
                tl.add(reel.start(), isQuickStop ? 0 : 0.05*fixedIndex)
                tl.add(Outsourced.reelView.startConveyorBelt(Math.floor(fixedIndex / 4), fixedIndex % 4), 0.05 * fixedIndex);
            });
        }

        tl.add(() => { flowStateController.finish() });
    }
}